import React from "react";
import injectSheet from "react-jss";
import { CheckCircle } from "../../";

const Tile = (props) => {
	const { classes, conflicts, disabled, index, isSelected, onClick, requires } =
		props;

	const clash =
		(conflicts && conflicts.length > 0) || (requires && requires.length > 0);

	return (
		<div
			className={`${classes.tileButton}
        ${isSelected && "selected"}
        ${disabled && "disabled"}
        ${clash && "clash"}`}
			role="button"
			tabIndex={index}
			onClick={disabled ? (e) => e : onClick}
			onKeyDown={disabled ? (e) => e : onClick}
		>
			<div className={`${classes.checkCircle}`}>
				<CheckCircle conflicts={conflicts} requires={requires} />
			</div>
			{props.children}
		</div>
	);
};

const styles = (theme) => ({
	tileButton: {
		width: "100%",
		height: "100%",
		overflow: "hidden",
		padding: 0,
		cursor: "pointer",
		color: theme.colors.secondary_3b,
		"&.selected.clash": {
			outlineColor: theme.colors.main_4,
		},
		"&.selected $checkCircle": {
			opacity: 1,
		},
		"&.clash $checkCircle": {
			backgroundColor: theme.colors.main_4,
			"&:hover": {
				width: "100%",
				height: "100%",
				top: 0,
				right: 0,
				borderRadius: 0,
				padding: `${theme.sizes.gutter / 2}px`,
			},
		},
		"& > *:not($checkCircle)": {
			opacity: 1,
			transition: [
				{
					property: "opacity",
					duration: theme.speed.fast,
				},
				{
					property: "transform",
					duration: theme.speed.fast,
				},
			],
		},
		"&.disabled > *:not($checkCircle)": {
			cursor: "auto",
			opacity: 0.2,
		},
	},
	checkCircle: {
		overflow: "hidden",
		position: "absolute",
		top: "20px",
		right: "20px",
		width: "40px",
		height: "40px",
		borderRadius: "50%",
		backgroundColor: theme.colors.main_1,
		opacity: 0,
		zIndex: 1,
		padding: 0,
		transition: [
			{
				property: "opacity",
				duration: theme.speed.fast,
			},
			{
				property: "width",
				duration: theme.speed.fast,
			},
			{
				property: "height",
				duration: theme.speed.fast,
			},
			{
				property: "top",
				duration: theme.speed.fast,
			},
			{
				property: "right",
				duration: theme.speed.fast,
			},
			{
				property: "border-radius",
				duration: theme.speed.fast,
			},
			{
				property: "padding",
				duration: theme.speed.fast,
			},
		],
	},
});

export default injectSheet(styles)(Tile);



// WEBPACK FOOTER //
// ./src/modules/core/components/tile.jsx